import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export interface DeleteBoxFileResult {
  fileId: string;
  status: string;
  message?: string;
}

export interface DeleteBoxFilesState {
  loading: boolean;
  success: boolean;
  error: string | null;
  results: DeleteBoxFileResult[];
}

const initialState: DeleteBoxFilesState = {
  loading: false,
  success: false,
  error: null,
  results: [],
};

// Async thunk
export const deleteBoxFiles = createAsyncThunk<
  DeleteBoxFileResult[],
  { fileIds: string[]; deleteBy: string },
  { rejectValue: string }
>(
  "boxFiles/deleteBoxFiles",
  async ({ fileIds, deleteBy }, { rejectWithValue }) => {
    try {
      const res = await api.delete(
        `/api/delete/files`,
        {
          data: { fileIds, deleteBy },
        }
      );
      return res.data.results;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete Box files"
      );
    }
  }
);

// Slice
const boxFileSlice = createSlice({
  name: "boxFiles",
  initialState,
  reducers: {
    resetDeleteState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.results = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBoxFiles.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(deleteBoxFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.results = action.payload;
      })
      .addCase(deleteBoxFiles.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetDeleteState } = boxFileSlice.actions;
export default boxFileSlice.reducer;
